const BASE_URL = process.env.BASE_URL || window.location.origin;

// Define the navigation links
export const navbar1 = () => {
  const navbarLinks = [
    { name: 'Home', path: '/' },
    { name: 'blog', path: '/blog/blog-page.html' },
    { name: 'Play', path: '/blog/play.html' },
  ];

  // Dynamically populate the navbar
  const navbar = document.querySelector('.navbar-ul');
  if (!navbar) {
    console.error('Navbar element not found');
    return;
  }

  navbarLinks.forEach(link => {
    const ul = document.querySelector('ul');
    if (!ul) {
      console.error('UL element not found');
      return;
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('class', 'nav-a');
    a.href = `${BASE_URL}${link.path}`;
    a.textContent = link.name;
    ul.appendChild(li);
    li.appendChild(a);
  });
};

export const navbar2 = () => {
  const navbar2Links = [
    { name: 'web-dev', path: '/blog/web-dev/web-dev-page.html' },
    { name: 'stories-from-syntax', path: '/blog/stories_from_syntax/stories.html' }
  ];

  // Dynamically populate the navbar
  const navbar2 = document.querySelector('.navbar2');
  if (!navbar2) {
    console.error('Navbar2 element not found');
    return;
  }

  navbar2Links.forEach(link => {
    const ul = document.createElement('ul');
    ul.classList.add('main-nav-2');
    ul.setAttribute('id', 'js-menu');
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('class', 'nav-links-2');
    a.href = `${BASE_URL}${link.path}`;
    a.textContent = link.name;
    ul.appendChild(li);
    li.appendChild(a);
    navbar2.appendChild(ul);
  });
};

